import type { BoxProps, MotionPropsFor } from '@hover/blueprint';
import { forwardRef, motion, system } from '@hover/blueprint';
import React from 'react';

const Container = motion(system.div);

type SectionVisibilityWrapperProps = {
  sectionId: string;
  setSectionInView: (sectionId: string) => void;
} & MotionPropsFor<BoxProps>;

export const SectionVisibilityWrapper = forwardRef(
  (
    {
      children,
      sectionId,
      setSectionInView,
      ...props
    }: SectionVisibilityWrapperProps,
    ref,
  ) => (
    <Container
      id={sectionId}
      ref={ref}
      {...props}
      onViewportEnter={() => setSectionInView(sectionId)}
      viewport={{ amount: 0.45 }}
    >
      {children}
    </Container>
  ),
);
